module.exports = __webpack_public_path__ + "static/media/flagRed.415cc3fe.svg";